export default {
    title: 'Meet your partner',
    safeHands: 'You are in safe hands',
    safeHandsText: `Brand new and independent matrimonial website, we work around the clock to provide the best services for our customers.<br><br>

    We are happy to have you visit our site and suggest you register now to become members and make use of the website services.<br><br>
    
    Best wishes,<br>
    Sharekomry Administration`,
    getApp: 'Download our App',
    getAppText: 'Download our Application for the bext experience. Get it from Google Playstore or App Store',
    aboutUs: 'About us',
    aboutUsText:
        'Brand new and independent matrimonial website, we work around the clock to provide the best services for our customers. We are happy to have you visit our site and suggest you register now to become members and make use of the website services.',
    contactUs: 'Contact us',
    contactUsButton: 'Send us a message',
    online: 'Online'
}
